import * as actions from '../actions';

export default function (
  state = {
    enums: {
      suspensionCategories: [],
      verticalTypes: [],
      rcsUseCases: [],
      tenDlcUseCases: [],
      smsUseCases: [],
      countries: {},
      mnos: [],
    },
    loadingMessage: '',
  },
  action
) {
  switch (action.type) {
    case actions.ADD_ENUM_SUSPENSION_CATEGORY:
      return {
        ...state,
        enums: {
          ...state.enums,
          suspensionCategories: action.payload,
        },
      };
    case actions.ADD_ENUM_VERTICAL_TYPE:
      return {
        ...state,
        enums: {
          ...state.enums,
          verticalTypes: action.payload,
        },
      };
    case actions.ADD_ENUM_RCS_USE_CASE:
      return {
        ...state,
        enums: {
          ...state.enums,
          rcsUseCases: action.payload,
        },
      };
    case actions.ADD_ENUM_10DLC_USE_CASE:
      return {
        ...state,
        enums: {
          ...state.enums,
          tenDlcUseCases: action.payload,
        },
      };
    case actions.SET_LOADING_MESSAGE:
      return {
        ...state,
        loadingMessage: action.payload,
      };
    case actions.CLEAR_LOADING_MESSAGE:
      return {
        ...state,
        loadingMessage: '',
      };
    case actions.ADD_ENUM_SMS_USE_CASE:
      return {
        ...state,
        enums: {
          ...state.enums,
          smsUseCases: action.payload,
        },
      };
    case actions.ADD_ENUM_COUNTRY:
      return {
        ...state,
        enums: {
          ...state.enums,
          countries: action.payload,
        },
      };
    case actions.ADD_ENUM_MNO:
      return {
        ...state,
        enums: {
          ...state.enums,
          mnos: action.payload,
        },
      };
    default:
      return state;
  }
}
